import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { OVERDUE_INVOICES } from "./apiRoutes";

// Define the expected response type
interface OverdueInvoice {
  schoolName: string;
  expectedInvoiceClearanceDate: string;
  invoiceOwner: string;
  paymentReceived: boolean;
}

interface OverdueInvoicesResponse {
  data: { items: OverdueInvoice[] };
}

const fetchOverdueInvoices = async () => {
  const response = await axiosAuth.get<OverdueInvoicesResponse>(OVERDUE_INVOICES);
  return response.data;
};

export const useGetOverdueInvoicesQuery = (
  queryParams?: UseQueryOptions<OverdueInvoicesResponse, Error, OverdueInvoicesResponse, ["overdueInvoices"]>
) =>
  useQuery<OverdueInvoicesResponse, Error, OverdueInvoicesResponse, ["overdueInvoices"]>({
    queryKey: ["overdueInvoices"],
    queryFn: fetchOverdueInvoices,
    ...(queryParams as any),
  });
